import { authMiddleware } from "@/middleware";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardLayout } from "@/components";
import NewProxyPage from "@/pages/proxies/New/Index";

export const Route = createFileRoute("/_market/proxy/new")({
	component: () => (
		<DashboardLayout>
			<NewProxyPage />
		</DashboardLayout>
	),
	loader: authMiddleware,
});
